import React from "react";

import type { AssignmentTestAttemptDetail } from "./AssignmentResponseDetailPage.types";
import { formatResponseCreated } from "./assignmentReview.utils";
import {
  AnswerLine,
  AttachmentName,
  Question,
  QuestionComment,
  QuestionHead,
  QuestionNumber,
  Questions,
  QuestionState,
  QuestionText,
  ResultHeader,
  ResultScore,
  ResultSection,
  ResultTitle,
} from "./AssignmentTestAttemptResult.styles";

interface AssignmentTestAttemptResultProps {
  attempt: AssignmentTestAttemptDetail;
}

const joinOptionTexts = (values: string[]) => values.length > 0 ? values.join(", ") : "не выбрано";

const AssignmentTestAttemptResult: React.FC<AssignmentTestAttemptResultProps> = ({ attempt }) => {
  const questions = [...(attempt.snapshot?.questions || [])].sort((a, b) => a.order - b.order);
  const submittedAt = formatResponseCreated(attempt.submitted_at);

  return (
    <ResultSection aria-label="Результат теста">
      <ResultHeader>
        <ResultTitle>Результат теста</ResultTitle>
        <ResultScore>
          {attempt.correct_count === null ? "Ответы сохранены без автоматической оценки" : <><strong>{attempt.correct_count} из {attempt.graded_count ?? attempt.question_count}</strong> · {attempt.percent}%</>} · {submittedAt}
          {attempt.graded_count !== undefined && attempt.graded_count > 0 && attempt.graded_count < attempt.question_count ? ` · Без автопроверки: ${attempt.question_count - attempt.graded_count}` : ""}
        </ResultScore>
      </ResultHeader>

      <Questions>
        {questions.map((question, index) => {
          const options = [...question.options].sort((a, b) => a.order - b.order);
          const selected = options.filter((option) => option.selected).map((option) => option.text);
          const correct = options.filter((option) => option.is_correct).map((option) => option.text);

          return (
            <Question key={`${question.question_id}-${index}`}>
              <QuestionHead>
                <QuestionNumber>Вопрос {index + 1}</QuestionNumber>
                {question.is_correct === null ? <QuestionComment>Без автоматической оценки</QuestionComment> : <QuestionState $correct={question.is_correct}>
                  {question.is_correct ? "Верно" : "Неверно"}
                </QuestionState>}
              </QuestionHead>
              <QuestionText>{question.text}</QuestionText>
              {question.comment ? <QuestionComment>{question.comment}</QuestionComment> : null}
              <AnswerLine $correct={question.is_correct ?? undefined}>
                <strong>Выбрано:</strong> {joinOptionTexts(selected)}
              </AnswerLine>
              {question.is_correct === false ? (
                <AnswerLine>
                  <strong>Правильный ответ:</strong> {joinOptionTexts(correct)}
                </AnswerLine>
              ) : null}
              {question.attachment_name ? (
                <AttachmentName>Вложение: {question.attachment_name}</AttachmentName>
              ) : null}
            </Question>
          );
        })}
      </Questions>
    </ResultSection>
  );
};

export default AssignmentTestAttemptResult;
